// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__--cGb","top":"styles_top__3B3pB","left":"styles_left__S34lx","description":"styles_description__3lyPb"};